<app-access-item [hideOverflow]="true">
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/watermark.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <span>Watermark</span>
    <app-upgrade-badge scope="watermark:create" location="gallery-watermark-setting-item"></app-upgrade-badge>
  </app-access-item-header>
  <app-access-item-cta>
    <app-switch [smallish]="true">
      <input
        type="checkbox"
        id="gallery-watermark-setting"
        [(ngModel)]="galleryWatermark"
        (ngModelChange)="updateGalleryWatermark()"
        [disabled]="!('watermark:create' | billingScope)"
      />
      <label for="gallery-watermark-setting" data-test-id="gallery-watermark-setting"></label>
    </app-switch>
  </app-access-item-cta>
</app-access-item>

@if (galleryWatermark()) {
  <div [@watermarkSettings] class="watermark-settings">
    @if (watermarks()?.length) {
      <app-context-menu [options]="{ noSpacing: true }" #menu>
        <button
          appButton
          contextButton
          name="watermark-dropdown"
          location="gallery-watermark-setting"
          height="0"
          size="0-5"
          shape="round"
          weight="bold"
          [hasIcon]="true"
        >
          <span>{{ selectedWatermark()?.name || 'Choose' }}</span>
          <app-svg src="/assets/icons/16/chevron-down.svg" size="-1"></app-svg>
        </button>

        <div class="button-menu" contextContent>
          @for (watermark of watermarks(); track watermark.id) {
            <div
              class="watermark"
              [class.selected]="watermark.id === selectedWatermark()?.id"
              data-test-id="select-watermark"
              appClickTrack
              name="select-watermark"
              location="gallery-watermark-setting"
              (click)="selectWatermark(watermark); menu.close()"
            >
              <div class="watermark-preview">
                <img
                  [src]="watermark?.original_key | watermarkUrl"
                  [style.opacity]="watermark.opacity"
                  alt=""
                  loading="lazy"
                />
              </div>
              <span>{{ watermark.name }}</span>
              @if (watermark.id === selectedWatermark()?.id) {
                <app-svg src="/assets/icons/check.svg" post class="some-check"></app-svg>
              }
            </div>
          }
        </div>
      </app-context-menu>

      @if (selectedWatermark() && currentWatermark()?.id !== selectedWatermark()?.id) {
        <button
          appButton
          name="apply"
          location="gallery-watermark-setting"
          color="primary"
          height="0"
          size="0-5"
          spacing="3"
          shape="round"
          (click)="applyWatermark()"
          data-test-id="apply-watermark"
        >
          <span>Apply</span>
        </button>
      }
    } @else {
      <a
        appButton
        name="add-watermark"
        location="gallery-watermark-setting"
        [routerLink]="['/a/settings/watermarks']"
        color="primary"
        height="0"
        size="0-5"
        shape="round"
      >
        Create Watermark
      </a>
    }
  </div>
}
